import { __exportAll } from "./_virtual/_rolldown/runtime.js";
//#region src/i9n_constants.ts
var i9n_constants_exports = /* @__PURE__ */ __exportAll({
	ArcherTestPassword: () => ArcherTestPassword,
	ArcherTestUsername: () => ArcherTestUsername,
	HeartlandProdUpdateUrl: () => HeartlandProdUpdateUrl,
	HeartlandTestUpdateUrl: () => HeartlandTestUpdateUrl,
	WorldpayApplicationId: () => WorldpayApplicationId
});
const ArcherTestUsername = "test_user";
const ArcherTestPassword = "test_password";
const HeartlandProdUpdateUrl = "SSLHPS.PROD.HPSDNLD.NET";
const HeartlandTestUpdateUrl = "SSLHPS.TEST.HPSDNLD.NET";
const WorldpayApplicationId = "9923";
//#endregion
export { ArcherTestPassword, ArcherTestUsername, HeartlandProdUpdateUrl, HeartlandTestUpdateUrl, WorldpayApplicationId, i9n_constants_exports };

//# sourceMappingURL=i9n_constants.js.map